export const PushPubSubDBGroup = 'push-pub-sub';
//# sourceMappingURL=shared.js.map